module.exports = __webpack_public_path__ + "img/box6-12.340b101e.png";